// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  holdId: __t.u64().primaryKey().name("hold_id"),
  listingId: __t.u64().name("listing_id"),
  versonaId: __t.u64().name("versona_id"),
  identity: __t.identity(),
  qty: __t.u32(),
  expiresTick: __t.u64().name("expires_tick"),
});
